webpackJsonp([16],{

/***/ "/wAz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4650":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__("Dd8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vux_src_plugins_ajax_index_js__ = __webpack_require__("yD8N");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs__ = __webpack_require__("mw3O");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_qs__);





__WEBPACK_IMPORTED_MODULE_1_vux_src_plugins_ajax_index_js__["a" /* default */].$http.defaults.timeout = 30000;
__WEBPACK_IMPORTED_MODULE_1_vux_src_plugins_ajax_index_js__["a" /* default */].$http.defaults.baseURL = "https://m.lvyuetravel.com";

function handlerError(error, code, url) {
  if (window.lvyue_report_log && (code === -10000 || code === -9998)) {
    var responseMsg = error.response && error.response.status ? error.response.status + ' ' + error.response.statusText : '-';
    window.lvyue_report_log.postAjax({
      msg: '\u63A5\u53E3\u8C03\u7528\u53D1\u751F\u9519\u8BEF-' + (error.message || ''),
      extra_info: code === -9998 ? error.msg : responseMsg,
      url: url || '-'
    });
  }
}
__WEBPACK_IMPORTED_MODULE_1_vux_src_plugins_ajax_index_js__["a" /* default */].$http.interceptors.request.use(function (cfg) {
  var config = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, cfg);
  if (config.method === 'post') {
    config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    config.data = config.data ? config.data : {};
    config.data = __WEBPACK_IMPORTED_MODULE_2_qs___default.a.stringify(config.data);
  } else {
    config.params = config.params ? config.params : {};
  }

  if (config.params && config.params.timeout) {
    config.timeout = config.params.timeout;
  }

  config.headers.fromAgent = 'LVYUE H5 PC';
  return config;
}, function (error) {

  handlerError(error, -10000, error.config.url);
  if (error.response) {
    var msg = error.response.status;
    console.log(msg);
  }
  return {};
});

__WEBPACK_IMPORTED_MODULE_1_vux_src_plugins_ajax_index_js__["a" /* default */].$http.interceptors.response.use(function (response) {
  if (response.data.code === -9998) {
    handlerError(response.data, response.data.code, response.config.url);
  }

  return response.data;
}, function (error) {

  handlerError(error, -10000, error.config.url);
  return {};
});

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1_vux_src_plugins_ajax_index_js__["a" /* default */]);

/***/ }),

/***/ "JSjK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sensors; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sa_sdk_javascript__ = __webpack_require__("uYVh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sa_sdk_javascript___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sa_sdk_javascript__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util__ = __webpack_require__("s0MJ");
/* eslint-disable prefer-rest-params */



var shenceUrl = "https://shence.lvyuetravel.com/sa?project=production";
var sensors = {
  init: function init() {
    try {
      __WEBPACK_IMPORTED_MODULE_0_sa_sdk_javascript__["init"]({
        server_url: shenceUrl,
        // 如果神策代码中 `sensorsdata.min.js` 版本是 1.13.1 及以前版本，必须须配置 heatmap_url，
        // 高于此版本不需要配置。heatmap_url 神策分析中点击分析及触达分析功能代码，代码生成工具会自动生成
        // heatmap_url: heatmap,
        // web_url 神策分析中点击分析及触达分析功能会用到此地址，代码生成工具会自动生成。
        // 如果神策后台版本及 `sensorsdata.min.js` 均是 1.10 及以上版本，这个参数不需要配置。
        // web_url:"神策分析后台地址",
        use_app_track: true, // 配置打通 App 与 H5 的参数
        is_track_single_page: true,
        heatmap: {
          // 是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
          // 需要 JSSDK 版本号大于 1.7
          clickmap: 'default',
          // 是否开启触达注意力图，默认 default 表示开启，自动采集 $WebStay 事件，可以设置 'not_collect' 表示关闭
          // 需要 JSSDK 版本号大于 1.9.1
          scroll_notice_map: 'default'
        }
      });
      var distinctID = Object(__WEBPACK_IMPORTED_MODULE_1__util__["d" /* getQueryString */])('distinctID');
      if (distinctID) {
        __WEBPACK_IMPORTED_MODULE_0_sa_sdk_javascript__["identify"](distinctID, true);
      }
      __WEBPACK_IMPORTED_MODULE_0_sa_sdk_javascript__["registerPage"]({
        platformType: 'h5',
        open_id: distinctID || '-'
      });
      __WEBPACK_IMPORTED_MODULE_0_sa_sdk_javascript__["quick"]('autoTrackSinglePage', {
        platformType: 'h5',
        open_id: distinctID || '-'
      });
    } catch (e) {
      console.log(e);
    }
  },
  track: function track() {
    try {
      __WEBPACK_IMPORTED_MODULE_0_sa_sdk_javascript__["track"].apply(__WEBPACK_IMPORTED_MODULE_0_sa_sdk_javascript__, arguments);
    } catch (e) {
      console.log(e);
    }
  },
  quick: function quick() {
    try {
      __WEBPACK_IMPORTED_MODULE_0_sa_sdk_javascript__["quick"].apply(__WEBPACK_IMPORTED_MODULE_0_sa_sdk_javascript__, arguments);
    } catch (e) {
      console.log(e);
    }
  }
};

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/fastclick/lib/fastclick.js
var fastclick = __webpack_require__("v5o6");
var fastclick_default = /*#__PURE__*/__webpack_require__.n(fastclick);

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/babel-polyfill/lib/index.js
var lib = __webpack_require__("j1ja");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/vue-lazyload/vue-lazyload.esm.js
var vue_lazyload_esm = __webpack_require__("AXdl");

// EXTERNAL MODULE: ./node_modules/vux/src/plugins/wechat/index.js + 1 modules
var wechat = __webpack_require__("n6Wb");

// EXTERNAL MODULE: ./node_modules/vux/src/directives/transfer-dom/index.js
var transfer_dom = __webpack_require__("63CM");

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var App = ({
  name: "app",
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//

/* harmony default export */ var selectortype_script_index_0_src_App = ({
  name: "app",
  data: function data() {
    return {};
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-67ab2786","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('keep-alive',[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: App_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("QTpT")
  __webpack_require__("XQOo")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  selectortype_script_index_0_src_App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// EXTERNAL MODULE: ./node_modules/jquery/dist/jquery.js
var jquery = __webpack_require__("7t+N");
var jquery_default = /*#__PURE__*/__webpack_require__.n(jquery);

// EXTERNAL MODULE: ./node_modules/js-cookie/src/js.cookie.js
var js_cookie = __webpack_require__("lbHh");
var js_cookie_default = /*#__PURE__*/__webpack_require__.n(js_cookie);

// EXTERNAL MODULE: ./src/common/util.js
var util = __webpack_require__("s0MJ");

// EXTERNAL MODULE: ./src/common/sensors.js
var sensors = __webpack_require__("JSjK");

// EXTERNAL MODULE: ./src/common/apiPath.js
var apiPath = __webpack_require__("RW6l");

// CONCATENATED MODULE: ./src/common/share.js


// 根据id区分分享内容



var appId = "wx08f7c860edd7b3c9";
var nonceStr = 'Wm3WZYTPz0wzccnW';
/* global wx */

/* harmony default export */ var common_share = ((function () {
  var _ref = asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee(context, shareInfo) {
    var params, data, shareConfig;
    return regenerator_default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            params = {
              nonceStr: nonceStr,
              url: encodeURIComponent(window.location.href.split('#')[0])
            };
            _context.next = 3;
            return context.$http.get('' + apiPath["p" /* WECHAT_SIGNATURE */], { params: params });

          case 3:
            data = _context.sent;

            if (!data.success) {
              _context.next = 10;
              break;
            }

            if (!(!wx || !wx.config)) {
              _context.next = 7;
              break;
            }

            return _context.abrupt('return');

          case 7:
            wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: appId, // 必填，公众号的唯一标识
              timestamp: data.data.timestamp, // 必填，生成签名的时间戳
              nonceStr: nonceStr, // 必填，生成签名的随机串
              signature: data.data.signature, // 必填，签名，见附录1
              jsApiList: ['updateTimelineShareData', 'updateAppMessageShareData', 'translateVoice'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            });

            shareConfig = {
              title: shareInfo.title || '',
              imgUrl: shareInfo.img || '',
              link: window.location.href,
              desc: shareInfo.desc || '#带你看世界，只为更美的旅程#'
            };
            // 接口取内容

            wx.ready(function () {
              var timer = 0;
              var count = 0;
              shareConfig.success = function () {
                timer = setTimeout(function () {
                  context.$http.get('' + apiPath["o" /* WECHAT_SHARE */]).then(function (res) {
                    if (res.data.success) {
                      if (res.data.data) {
                        // 今日首次分享
                        console.log(res);
                      }
                    }
                  });
                }, 500);

                if (count >= 1) {
                  clearTimeout(timer);
                } else {
                  count += 1;
                }
              };
              // 分享到朋友圈
              wx.updateTimelineShareData(shareConfig);
              // 分享给朋友
              wx.updateAppMessageShareData(shareConfig);
            });

          case 10:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));

  function share(_x, _x2) {
    return _ref.apply(this, arguments);
  }

  return share;
})());
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var views = ({
  name: "index",
  data: function data() {
    return {
      error: false,
      title: "",
      bgColor: null,
      templateValues: [],
      pageId: "",
      populationActivityCode: "",
      populationChannelCode: "",
      activityStatus: 0,
      waitGetLogin: false, // 等待判断登录接口
      hasNavBottom: false,
      belongSystem: "ows" // 判断不同系统 {ows: 预售房, score-mall: 积分商城}
    };
  },

  components: {
    singlePic: function singlePic() {
      return __webpack_require__.e/* import() */(11/* duplicate */).then(__webpack_require__.bind(null, "NE6h"));
    },
    pictureCube: function pictureCube() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(4)]).then(__webpack_require__.bind(null, "cy/w"));
    },
    hotelList: function hotelList() {
      return __webpack_require__.e/* import() */(5/* duplicate */).then(__webpack_require__.bind(null, "AGWr"));
    },
    coupon: function coupon() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(__webpack_require__.bind(null, "2wLF"));
    },
    navBottom: function navBottom() {
      return __webpack_require__.e/* import() */(14/* duplicate */).then(__webpack_require__.bind(null, "8r7U"));
    },
    rotationPicture: function rotationPicture() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(3)]).then(__webpack_require__.bind(null, "Ka3q"));
    },
    score: function score() {
      return __webpack_require__.e/* import() */(7/* duplicate */).then(__webpack_require__.bind(null, "SVy8"));
    },
    lottery: function lottery() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(8)]).then(__webpack_require__.bind(null, "IWfa"));
    },
    register: function register() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(__webpack_require__.bind(null, "q3Wa"));
    },
    exchangeCode: function exchangeCode() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(10)]).then(__webpack_require__.bind(null, "wwVn"));
    },
    pictureNavigation: function pictureNavigation() {
      return __webpack_require__.e/* import() */(13/* duplicate */).then(__webpack_require__.bind(null, "81dD"));
    },
    goodsGroup: function goodsGroup() {
      return __webpack_require__.e/* import() */(9/* duplicate */).then(__webpack_require__.bind(null, "s+QT"));
    },
    hotelListYushoufang: function hotelListYushoufang() {
      return __webpack_require__.e/* import() */(6/* duplicate */).then(__webpack_require__.bind(null, "PIv4"));
    },
    member: function member() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(12)]).then(__webpack_require__.bind(null, "TSAD"));
    }
  },
  created: function created() {
    this.pageInit();
  },
  mounted: function mounted() {
    sensors["a" /* sensors */].init();
  },

  methods: {
    pageInit: function pageInit() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var res, data, sensorsObj;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$http.get(apiPath["c" /* FIND_DETAIL */], {
                  params: {
                    id: _this.$route.params.id
                  },
                  type: _this.$route.query.type
                });

              case 2:
                res = _context.sent;
                data = res.data;

                if (data) {
                  // 存在底部导航
                  _this.hasNavBottom = data.templateValues.some(function (item) {
                    return item.type === "navigation";
                  });
                  _this.getLogin();

                  _this.bgColor = data.bgColor;
                  document.body.style.backgroundColor = data.bgColor;
                  _this.pageId = data.id;
                  _this.populationActivityCode = data.populationActivityCode;
                  util["g" /* global */].populationActivityCode = data.populationActivityCode;
                  _this.populationChannelCode = data.populationChannelCode;
                  util["g" /* global */].populationChannelCode = data.populationChannelCode;
                  _this.templateValues = data.templateValues;
                  data.belongSystem && (_this.belongSystem = data.belongSystem);
                  document.title = data.title;
                  _this.title = data.title;
                  _this.error = false;
                  // 分享
                  if (true) {
                    common_share(_this, {
                      title: data.shareTitle,
                      img: data.shareCover,
                      desc: data.shareDesc
                    });
                  }
                  if (res.serverTime >= data.startTime && res.serverTime <= data.endTime) {
                    _this.activityStatus = 0;
                  } else if (res.serverTime < data.startTime) {
                    _this.activityStatus = 1;
                  } else {
                    _this.activityStatus = 2;
                  }
                  sensorsObj = {
                    trigger_type: "页面曝光",
                    superior_page: Object(util["f" /* getTouchType */])(),
                    touch_type: Object(util["e" /* getSuperiorPage */])(),
                    activity_name: data.title,
                    template_module: "-",
                    template_module_name: "-",
                    check_content: "页面曝光"
                  };

                  sensors["a" /* sensors */].track("marketing_template", sensorsObj);
                } else {
                  _this.error = true;
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getLogin: function getLogin() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var res, that;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (Object(util["d" /* getQueryString */])("owsToken")) {
                  if (decodeURIComponent(Object(util["d" /* getQueryString */])("owsToken")).length > 2) {
                    js_cookie_default.a.set("ows_token", Object(util["d" /* getQueryString */])("owsToken"), {
                      domain: ".lvyuetravel.com",
                      expires: 15 * 60 * 1000,
                      path: "/"
                    });
                    util["g" /* global */].isLogin = true;
                  } else {
                    js_cookie_default.a.remove("ows_token", { domain: ".lvyuetravel.com", path: "/" });
                    js_cookie_default.a.remove("p_oid", { domain: ".lvyuetravel.com", path: "/" });
                  }
                }

                // 把url上的p_oid传入
                if (Object(util["d" /* getQueryString */])("p_oid")) {
                  js_cookie_default.a.set("p_oid", Object(util["d" /* getQueryString */])("p_oid"), {
                    domain: ".lvyuetravel.com",
                    expires: 60 * 60 * 1000,
                    path: "/"
                  });
                }

                if (js_cookie_default.a.get("ows_token") || js_cookie_default.a.get("p_oid")) {
                  util["g" /* global */].isLogin = true;
                }

                // 走获取用户信息确保判断登录准确
                _context2.next = 5;
                return _this2.$http.get(apiPath["d" /* GET_LOGIN_USER */]);

              case 5:
                res = _context2.sent;

                if (!res.data) {
                  util["g" /* global */].isLogin = false;
                } else {
                  util["g" /* global */].isLogin = true;
                  util["g" /* global */].userInfo = res.data;
                }
                _this2.waitGetLogin = true;
                that = _this2;


                jquery_default()(document).on("click", "#app > .wrap-body > div > div", function b() {
                  if (!that.templateValues.length) return;
                  var index = jquery_default()(this).index();
                  if (that.templateValues[index] && that.templateValues[index].name) {
                    var templateItem = that.templateValues[index];
                    var sensorsObj = {
                      trigger_type: "点击",
                      superior_page: Object(util["f" /* getTouchType */])(),
                      touch_type: Object(util["e" /* getSuperiorPage */])(),
                      activity_name: that.title,
                      template_module: index,
                      template_module_name: templateItem.name,
                      check_content: templateItem.name
                    };
                    sensors["a" /* sensors */].track("marketing_template", sensorsObj);
                  }
                });

                setTimeout(function () {
                  jquery_default()(document).on("scroll", function () {
                    jquery_default()("#app > .wrap-body > div > div").each(function (index, e) {
                      if (!jquery_default()(e).attr("sensors")) {
                        if (Object(util["k" /* isElementInViewport */])(e)) {
                          jquery_default()(e).attr("sensors", true);
                          var sensorsObj = {
                            trigger_type: "组件曝光",
                            superior_page: Object(util["f" /* getTouchType */])(),
                            touch_type: Object(util["e" /* getSuperiorPage */])(),
                            activity_name: that.title,
                            template_module: index,
                            template_module_name: _this2.templateValues[index].name,
                            check_content: _this2.templateValues[index].name
                          };
                          sensors["a" /* sensors */].track("marketing_template", sensorsObj);
                        }
                      }
                    });
                  }).trigger("scroll");
                }, 1000);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    reLoad: function reLoad() {
      window.location.reload();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vux-loader/src/script-loader.js!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/index.vue


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var selectortype_script_index_0_src_views = ({
  name: "index",
  data: function data() {
    return {
      error: false,
      title: "",
      bgColor: null,
      templateValues: [],
      pageId: "",
      populationActivityCode: "",
      populationChannelCode: "",
      activityStatus: 0,
      waitGetLogin: false, // 等待判断登录接口
      hasNavBottom: false,
      belongSystem: "ows" // 判断不同系统 {ows: 预售房, score-mall: 积分商城}
    };
  },

  components: {
    singlePic: function singlePic() {
      return __webpack_require__.e/* import() */(11/* duplicate */).then(__webpack_require__.bind(null, "NE6h"));
    },
    pictureCube: function pictureCube() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(4)]).then(__webpack_require__.bind(null, "cy/w"));
    },
    hotelList: function hotelList() {
      return __webpack_require__.e/* import() */(5/* duplicate */).then(__webpack_require__.bind(null, "AGWr"));
    },
    coupon: function coupon() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(__webpack_require__.bind(null, "2wLF"));
    },
    navBottom: function navBottom() {
      return __webpack_require__.e/* import() */(14/* duplicate */).then(__webpack_require__.bind(null, "8r7U"));
    },
    rotationPicture: function rotationPicture() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(3)]).then(__webpack_require__.bind(null, "Ka3q"));
    },
    score: function score() {
      return __webpack_require__.e/* import() */(7/* duplicate */).then(__webpack_require__.bind(null, "SVy8"));
    },
    lottery: function lottery() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(8)]).then(__webpack_require__.bind(null, "IWfa"));
    },
    register: function register() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(__webpack_require__.bind(null, "q3Wa"));
    },
    exchangeCode: function exchangeCode() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(10)]).then(__webpack_require__.bind(null, "wwVn"));
    },
    pictureNavigation: function pictureNavigation() {
      return __webpack_require__.e/* import() */(13/* duplicate */).then(__webpack_require__.bind(null, "81dD"));
    },
    goodsGroup: function goodsGroup() {
      return __webpack_require__.e/* import() */(9/* duplicate */).then(__webpack_require__.bind(null, "s+QT"));
    },
    hotelListYushoufang: function hotelListYushoufang() {
      return __webpack_require__.e/* import() */(6/* duplicate */).then(__webpack_require__.bind(null, "PIv4"));
    },
    member: function member() {
      return Promise.all/* import() */([__webpack_require__.e(0), __webpack_require__.e(12)]).then(__webpack_require__.bind(null, "TSAD"));
    }
  },
  created: function created() {
    this.pageInit();
  },
  mounted: function mounted() {
    sensors["a" /* sensors */].init();
  },

  methods: {
    pageInit: function pageInit() {
      var _this = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee() {
        var res, data, sensorsObj;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this.$http.get(apiPath["c" /* FIND_DETAIL */], {
                  params: {
                    id: _this.$route.params.id
                  },
                  type: _this.$route.query.type
                });

              case 2:
                res = _context.sent;
                data = res.data;

                if (data) {
                  // 存在底部导航
                  _this.hasNavBottom = data.templateValues.some(function (item) {
                    return item.type === "navigation";
                  });
                  _this.getLogin();

                  _this.bgColor = data.bgColor;
                  document.body.style.backgroundColor = data.bgColor;
                  _this.pageId = data.id;
                  _this.populationActivityCode = data.populationActivityCode;
                  util["g" /* global */].populationActivityCode = data.populationActivityCode;
                  _this.populationChannelCode = data.populationChannelCode;
                  util["g" /* global */].populationChannelCode = data.populationChannelCode;
                  _this.templateValues = data.templateValues;
                  data.belongSystem && (_this.belongSystem = data.belongSystem);
                  document.title = data.title;
                  _this.title = data.title;
                  _this.error = false;
                  // 分享
                  if (true) {
                    common_share(_this, {
                      title: data.shareTitle,
                      img: data.shareCover,
                      desc: data.shareDesc
                    });
                  }
                  if (res.serverTime >= data.startTime && res.serverTime <= data.endTime) {
                    _this.activityStatus = 0;
                  } else if (res.serverTime < data.startTime) {
                    _this.activityStatus = 1;
                  } else {
                    _this.activityStatus = 2;
                  }
                  sensorsObj = {
                    trigger_type: "页面曝光",
                    superior_page: Object(util["f" /* getTouchType */])(),
                    touch_type: Object(util["e" /* getSuperiorPage */])(),
                    activity_name: data.title,
                    template_module: "-",
                    template_module_name: "-",
                    check_content: "页面曝光"
                  };

                  sensors["a" /* sensors */].track("marketing_template", sensorsObj);
                } else {
                  _this.error = true;
                }

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    getLogin: function getLogin() {
      var _this2 = this;

      return asyncToGenerator_default()( /*#__PURE__*/regenerator_default.a.mark(function _callee2() {
        var res, that;
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (Object(util["d" /* getQueryString */])("owsToken")) {
                  if (decodeURIComponent(Object(util["d" /* getQueryString */])("owsToken")).length > 2) {
                    js_cookie_default.a.set("ows_token", Object(util["d" /* getQueryString */])("owsToken"), {
                      domain: ".lvyuetravel.com",
                      expires: 15 * 60 * 1000,
                      path: "/"
                    });
                    util["g" /* global */].isLogin = true;
                  } else {
                    js_cookie_default.a.remove("ows_token", { domain: ".lvyuetravel.com", path: "/" });
                    js_cookie_default.a.remove("p_oid", { domain: ".lvyuetravel.com", path: "/" });
                  }
                }

                // 把url上的p_oid传入
                if (Object(util["d" /* getQueryString */])("p_oid")) {
                  js_cookie_default.a.set("p_oid", Object(util["d" /* getQueryString */])("p_oid"), {
                    domain: ".lvyuetravel.com",
                    expires: 60 * 60 * 1000,
                    path: "/"
                  });
                }

                if (js_cookie_default.a.get("ows_token") || js_cookie_default.a.get("p_oid")) {
                  util["g" /* global */].isLogin = true;
                }

                // 走获取用户信息确保判断登录准确
                _context2.next = 5;
                return _this2.$http.get(apiPath["d" /* GET_LOGIN_USER */]);

              case 5:
                res = _context2.sent;

                if (!res.data) {
                  util["g" /* global */].isLogin = false;
                } else {
                  util["g" /* global */].isLogin = true;
                  util["g" /* global */].userInfo = res.data;
                }
                _this2.waitGetLogin = true;
                that = _this2;


                jquery_default()(document).on("click", "#app > .wrap-body > div > div", function b() {
                  if (!that.templateValues.length) return;
                  var index = jquery_default()(this).index();
                  if (that.templateValues[index] && that.templateValues[index].name) {
                    var templateItem = that.templateValues[index];
                    var sensorsObj = {
                      trigger_type: "点击",
                      superior_page: Object(util["f" /* getTouchType */])(),
                      touch_type: Object(util["e" /* getSuperiorPage */])(),
                      activity_name: that.title,
                      template_module: index,
                      template_module_name: templateItem.name,
                      check_content: templateItem.name
                    };
                    sensors["a" /* sensors */].track("marketing_template", sensorsObj);
                  }
                });

                setTimeout(function () {
                  jquery_default()(document).on("scroll", function () {
                    jquery_default()("#app > .wrap-body > div > div").each(function (index, e) {
                      if (!jquery_default()(e).attr("sensors")) {
                        if (Object(util["k" /* isElementInViewport */])(e)) {
                          jquery_default()(e).attr("sensors", true);
                          var sensorsObj = {
                            trigger_type: "组件曝光",
                            superior_page: Object(util["f" /* getTouchType */])(),
                            touch_type: Object(util["e" /* getSuperiorPage */])(),
                            activity_name: that.title,
                            template_module: index,
                            template_module_name: _this2.templateValues[index].name,
                            check_content: _this2.templateValues[index].name
                          };
                          sensors["a" /* sensors */].track("marketing_template", sensorsObj);
                        }
                      }
                    });
                  }).trigger("scroll");
                }, 1000);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    reLoad: function reLoad() {
      window.location.reload();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-62fc3aa7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/index.vue
var views_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.error)?_c('div',{staticClass:"wrap-body",style:({'background': _vm.bgColor})},[_c('div',{staticClass:"content clearfix",class:{'hasNavBottom':_vm.hasNavBottom}},[_vm._l((_vm.templateValues),function(item){return (_vm.templateValues.length)?[(item.type == 'score' && _vm.waitGetLogin)?_c('score',{attrs:{"initData":item}}):_vm._e(),_vm._v(" "),(item.type == 'rotationPicture')?_c('rotation-picture',{attrs:{"initData":item}}):_vm._e(),_vm._v(" "),(item.type == 'pictureNavigation')?_c('picture-navigation',{attrs:{"initData":item}}):_vm._e(),_vm._v(" "),(item.type == 'goodsGroup')?_c('goods-group',{attrs:{"initData":item}}):_vm._e(),_vm._v(" "),(item.type == 'singlePicture')?_c('singlePic',{attrs:{"initData":item}}):_vm._e(),_vm._v(" "),(item.type == 'pictureCube')?_c('pictureCube',{attrs:{"initData":item}}):_vm._e(),_vm._v(" "),(item.type == 'hotelGroup')?_c('hotelList',{attrs:{"initData":item}}):_vm._e(),_vm._v(" "),(item.type == 'mallGoodsGroup')?_c('hotelListYushoufang',{attrs:{"initData":item}}):_vm._e(),_vm._v(" "),(item.type == 'coupon')?_c('coupon',{attrs:{"initData":item,"pageId":_vm.pageId,"populationActivityCode":_vm.populationActivityCode,"populationChannelCode":_vm.populationChannelCode,"activityStatus":_vm.activityStatus}}):_vm._e(),_vm._v(" "),(item.type == 'navigation')?_c('navBottom',{attrs:{"initData":item}}):_vm._e(),_vm._v(" "),(item.type == 'lottery')?_c('lottery',{attrs:{"initData":item,"pageId":_vm.pageId,"populationActivityCode":_vm.populationActivityCode,"populationChannelCode":_vm.populationChannelCode}}):_vm._e(),_vm._v(" "),(item.type == 'login' && _vm.waitGetLogin)?_c('register',{attrs:{"initData":item,"pageId":_vm.pageId,"populationActivityCode":_vm.populationActivityCode,"populationChannelCode":_vm.populationChannelCode}}):_vm._e(),_vm._v(" "),(item.type == 'redeemCode')?_c('exchangeCode',{attrs:{"initData":item,"pageId":_vm.pageId,"populationActivityCode":_vm.populationActivityCode,"populationChannelCode":_vm.populationChannelCode}}):_vm._e(),_vm._v(" "),(item.type == 'memberCard')?_c('member',{attrs:{"initData":item,"populationActivityCode":_vm.populationActivityCode,"populationChannelCode":_vm.populationChannelCode,"activityStatus":_vm.activityStatus}}):_vm._e()]:_vm._e()})],2)]):_c('div',{staticClass:"error"},[_c('div',{staticClass:"img"}),_vm._v(" "),_c('div',{staticClass:"desc"},[_vm._v("网络环境有点差呀，重试下吧~")]),_vm._v(" "),_c('div',{staticClass:"bnt",attrs:{"name":"重新加载","data-sensors-click":""},on:{"click":_vm.reLoad}},[_vm._v("\n    重新加载\n  ")])])}
var views_staticRenderFns = []
var views_esExports = { render: views_render, staticRenderFns: views_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_views = (views_esExports);
// CONCATENATED MODULE: ./src/views/index.vue
function views_injectStyle (ssrContext) {
  __webpack_require__("Zph2")
}
var views_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var views___vue_template_functional__ = false
/* styles */
var views___vue_styles__ = views_injectStyle
/* scopeId */
var views___vue_scopeId__ = "data-v-62fc3aa7"
/* moduleIdentifier (server only) */
var views___vue_module_identifier__ = null
var views_Component = views_normalizeComponent(
  selectortype_script_index_0_src_views,
  selectortype_template_index_0_src_views,
  views___vue_template_functional__,
  views___vue_styles__,
  views___vue_scopeId__,
  views___vue_module_identifier__
)

/* harmony default export */ var src_views = (views_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js



/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: '/activities',
  routes: [{
    path: '/multi/:id',
    name: 'index',
    component: src_views,
    props: function props(route) {
      return { query: route.query.type };
    }
  }]
}));
// EXTERNAL MODULE: ./src/common/request.js
var request = __webpack_require__("4650");

// EXTERNAL MODULE: ./src/assets/font/iconfont.css
var iconfont = __webpack_require__("/wAz");
var iconfont_default = /*#__PURE__*/__webpack_require__.n(iconfont);

// CONCATENATED MODULE: ./src/main.js
/* eslint-disable no-underscore-dangle */














vue_esm["a" /* default */].directive('transfer-dom', transfer_dom["a" /* default */]);

var imgDefault = __webpack_require__("cRNA");

vue_esm["a" /* default */].use(wechat["a" /* default */]);
vue_esm["a" /* default */].use(vue_router_esm["a" /* default */]);
vue_esm["a" /* default */].use(request["a" /* default */]);

vue_esm["a" /* default */].use(vue_lazyload_esm["a" /* default */], {
  preLoad: 2,
  error: imgDefault,
  attempt: 1
});
fastclick_default.a.attach(document.body);

vue_esm["a" /* default */].config.productionTip = false;

function formatComponentName(vm) {
  if (vm.$root === vm) return 'root';
  var name = vm._isVue ? vm.$options && vm.$options.name || vm.$options && vm.$options._componentTag : vm.name;
  return (name ? 'component <' + name + '>' : 'anonymous component') + (vm._isVue && vm.$options && vm.$options.__file ? ' at ' + (vm.$options && vm.$options.__file) : '');
}
vue_esm["a" /* default */].config.errorHandler = function (error, vm, info) {
  console.log('errorHandler:', error);
  var params = {
    msg: '' + error,
    extra_info: {
      info: info || "-",
      componentName: vm ? formatComponentName(vm) : '-'
    }
  };
  if (window.lvyue_report_log) {
    window.lvyue_report_log.postAjax(params, "componentDidCatch");
  }
  window.location.replace('https://m.lvyuetravel.com/inHotel/ErrorPage?redirect_uri=' + window.location.href);
};
/* eslint-disable no-new */
new vue_esm["a" /* default */]({
  data: {
    Bus: new vue_esm["a" /* default */]()
  },
  router: router,
  render: function render(h) {
    return h(src_App);
  }
}).$mount('#app');

/***/ }),

/***/ "QTpT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "RW6l":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return FIND_DETAIL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BATCH_NOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return HOTEL_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return SPU_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return SEND_SMS_CODE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return USER_LOGIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return NEW_USER_LOGIN; });
/* unused harmony export BUILD_URL */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return WECHAT_SIGNATURE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return WECHAT_SHARE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return RECEIVE_ACTIVITY_COUPON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GET_LOGIN_USER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return LOTTERY_STATUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return LOTTERY_RECORD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return LOTTERY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return EXCHANGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GET_MEMBER; });
var FIND_DETAIL = '/api/cms/marketing/page/find_detail.json'; // 页面详情
var BATCH_NOS = 'api/ows/market/coupon/query_by_batch_nos.json'; // 优惠券批次号批量查询
var HOTEL_LIST = 'api/hotel/batch_search.json'; // 酒店列表
var SPU_LIST = 'api/mall/product/query/list/spu_ids.json'; // 列表
var SEND_SMS_CODE = 'sys/sms-code.json'; // 发送验证码
var USER_LOGIN = 'api/hotel/user/login.json'; // 登录
var NEW_USER_LOGIN = 'ops/login.json'; // 新用户登录
var BUILD_URL = 'api/wallet/build_url.json'; //
var WECHAT_SIGNATURE = 'api/gateway/wechat/signature.json'; // 分享
var WECHAT_SHARE = 'api/hotel/user/member/wechat/share.json'; // 分享调用的接口
var RECEIVE_ACTIVITY_COUPON = 'ops/coupon/receive_by_activity_batch.json'; // 领取优惠券
var GET_LOGIN_USER = 'api/hotel/user/get_login_user.json'; // 用户信息

var LOTTERY_STATUS = 'ops/lottery/lottery_status.json'; // 抽奖状态，剩余次数等
var LOTTERY_RECORD = 'ops/lottery/lottery_record.json'; // 抽奖记录
var LOTTERY = 'ops/lottery/lottery.json'; // 抽奖
var EXCHANGE = 'api/hotel/user/redeemCode/exchange.json'; // 兑换码
var GET_MEMBER = 'ops/member/popularize.json'; // 领会员

/***/ }),

/***/ "XQOo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Zph2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cRNA":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "s0MJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return global; });
/* harmony export (immutable) */ __webpack_exports__["i"] = handlerCallbackStack;
/* unused harmony export isAndroid */
/* unused harmony export isIos */
/* unused harmony export isWeixin */
/* unused harmony export isBaiDu */
/* unused harmony export isXhs */
/* unused harmony export isAlipayClient */
/* harmony export (immutable) */ __webpack_exports__["m"] = openInWebview;
/* unused harmony export loadURL */
/* harmony export (immutable) */ __webpack_exports__["d"] = getQueryString;
/* harmony export (immutable) */ __webpack_exports__["n"] = pxFormat;
/* unused harmony export openInHuazhuWebview */
/* harmony export (immutable) */ __webpack_exports__["j"] = imgFormat;
/* unused harmony export jumpPage */
/* unused harmony export toXCX */
/* unused harmony export toAppHome */
/* harmony export (immutable) */ __webpack_exports__["p"] = toHotelDetail;
/* harmony export (immutable) */ __webpack_exports__["q"] = toHuafenDetail;
/* unused harmony export toHotelList */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HuazhuJsbridge; });
/* harmony export (immutable) */ __webpack_exports__["l"] = login;
/* harmony export (immutable) */ __webpack_exports__["h"] = goUrl;
/* harmony export (immutable) */ __webpack_exports__["o"] = scoreFormat;
/* harmony export (immutable) */ __webpack_exports__["c"] = copyToClipboard;
/* harmony export (immutable) */ __webpack_exports__["b"] = changeAreaCode;
/* unused harmony export isExternal */
/* unused harmony export debounce */
/* unused harmony export throttle */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getTouchType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getSuperiorPage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return isElementInViewport; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__("lbHh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sensors__ = __webpack_require__("JSjK");

/* global wx */
/* global swan */
/* global androidObj */
/* global my */
/* eslint-disable func-names */



var global = {
  isLogin: false,
  populationActivityCode: '',
  populationChannelCode: '',
  userInfo: {}
};

var callbackMap = {};

function handlerCallbackStack(_ref) {
  var type = _ref.type,
      handler = _ref.handler;

  if (!handler) {
    callbackMap[type] && callbackMap[type].forEach(function (cur) {
      cur();
    });
  } else {
    if (callbackMap[type]) {
      callbackMap[type].push(handler);
    } else {
      callbackMap[type] = [handler];
    }
  }
}

function isAndroid() {
  var u = navigator.userAgent;
  var android = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1;
  if (android) {
    return true;
  }
  return false;
}

function isIos() {
  var u = navigator.userAgent;
  var ios = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
  if (ios) {
    return true;
  }
  return false;
}

function isWeixin() {
  var ua = navigator.userAgent.toLowerCase();
  var weixin = ua.match(/MicroMessenger/i) ? ua.match(/MicroMessenger/i).toString() === "micromessenger" : false;
  if (weixin) {
    return true;
  }
  return false;
}

function isBaiDu() {
  var ua = navigator.userAgent.toLowerCase();
  var isbaidu = ua.match(/baiduboxapp/i) ? ua.match(/baiduboxapp/i).toString() === "baiduboxapp" : false;
  if (isbaidu) {
    return true;
  }
  return false;
}

// https://miniapp.xiaohongshu.com/docs/component/web-view
function isXhs() {
  return navigator.userAgent.toLowerCase().includes('xhsminiapp');
}

function isAlipayClient() {
  var ua = navigator.userAgent.toLowerCase();
  var alipayClient = ua.match(/alipayclient/i) ? ua.match(/alipayclient/i).toString() === "alipayclient" : false;
  if (alipayClient) {
    return true;
  }
  return false;
}

// 判断是否是在APP内
function openInWebview() {
  var ua = navigator.userAgent.toLowerCase();
  var Android = /com.lvyuetravel.huazhu.client_Android/i;
  var IOS = /com.lvyuetravel.huazhu.client_iOS/i;
  if (ua.match(Android) != null || ua.match(IOS) != null) {
    return true;
  }
  return false;
}

// 发出一个请求，用于与原生进行交互
function loadURL(url) {
  var iFrame = void 0;
  iFrame = document.createElement("iframe");
  iFrame.setAttribute("src", url);
  iFrame.setAttribute("style", "display:none;");
  iFrame.setAttribute("height", "0px");
  iFrame.setAttribute("width", "0px");
  iFrame.setAttribute("frameborder", "0");
  document.body.appendChild(iFrame);
  // 发起请求后这个 iFrame 就没用了，所以把它从 dom 上移除掉
  iFrame.parentNode.removeChild(iFrame);
  iFrame = null;
}

function getQueryString(name, search) {
  var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
  !search && (search = window.location.search.substr(1));
  var r = search.match(reg);
  if (r != null) {
    return unescape(r[2]);
  }
  return null;
}

function pxFormat(d) {
  var rem = 375 / 10;
  var val = parseFloat(d) / rem;
  val += 'rem';
  return val;
}

// 精确判断是否是在APP内 返回版本
function openInHuazhuWebview() {
  var ua = navigator.userAgent.toLowerCase();
  var Android = /com.lvyuetravel.huazhu.client_Android/i;
  var IOS = /com.lvyuetravel.huazhu.client_iOS/i;
  var Android_version = /com.lvyuetravel.huazhu.client_Android\/\S+\//i;
  var IOS_version = /com.lvyuetravel.huazhu.client_iOS\/\S+\//i;
  var obj = {};
  var IOS_12 = /IPHONE OS 12_/i;
  if (ua.match(Android) != null) {
    obj.type = 'android';
    var str = ua.match(Android_version) ? ua.match(Android_version)[0] : '';
    var versionStr = str ? str.match(/\/\S+\//)[0] : null;
    var version = 0;
    if (versionStr) {
      version = versionStr.split('/')[1];
      version ? version = version.replace(/\./g, '') : 0;
    }
    obj.version = version;
  } else if (ua.match(IOS) != null) {
    obj.type = 'ios';
    var _str = ua.match(IOS_version) ? ua.match(IOS_version)[0] : '';
    var _version = _str ? _str.match(/\/\S+\//)[0].replace(/\//g, '').replace(/\./g, '') : 0;
    obj.version = _version;
  } else {
    if (ua.match(IOS_12) != null) {
      if (ua.match(/MicroMessenger/i).toString() === 'micromessenger') {
        // 微信浏览器判断
        return false;
      } else if (ua.match(/QQ/i).toString() === 'qq') {
        // QQ浏览器判断
        return false;
      } else if (ua.match(/WeiBo/i).toString() === "weibo") {
        return false;
      }
      return ua.match(/safari/i) == null ? {} : false;
    }
    obj = false;
  }
  return obj;
}

var webpCanUse = document.createElement('canvas').toDataURL('image/webp').indexOf('data:image/webp') === 0;

function imgFormat(value, width, height) {
  var back = '' + value;
  if (width && height || webpCanUse) {
    back += '?x-oss-process=image';
    if (width && height) {
      back += '/resize,m_fill,w_' + width + ',h_' + height;
    }
    if (webpCanUse) {
      back += '/format,webp';
    }
  }
  return back;
}

function jumpPage() {
  var link = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    wxUrl: '',
    baidu: '',
    alipay: '',
    android: '',
    ios: '',
    h5: '',
    XCXType: 1 // 小程序类型：1 花筑旅行 2 花粉去哪儿,默认不传则是花筑旅行
  };
  var context = arguments[1];
  var versionCallBack = arguments[2];

  if (isWeixin()) {
    // 微信小程序
    try {
      wx.miniProgram.getEnv(function (res) {
        if (res.miniprogram) {
          if (link.wxUrl.indexOf('pages/index/index') > -1) {
            wx.miniProgram.switchTab({ url: link.wxUrl });
          } else {
            if (link.XCXType === 2 && getQueryString('xcxType') === 'hzlx') {
              wx.miniProgram.postMessage({ // 跳转到其他小程序使用发通知的方式
                data: {
                  type: "toMini",
                  appId: 'wxf7a04d7660b61438',
                  path: link.wxUrl
                }
              });
              // 网页向小程序 postMessage 时，会在特定时机（小程序后退、组件销毁、分享）触发并收到消息。
              wx.miniProgram.navigateBack();
            } else {
              wx.miniProgram.navigateTo({ url: link.wxUrl });
            }
          }
        } else {
          window.location.href = link.h5;
        }
      });
    } catch (e) {
      window.location.href = link.h5;
    }
  } else if (isBaiDu()) {
    // 百度小程序
    try {
      swan.webView.getEnv(function (res) {
        if (res.smartprogram) {
          if (link.baidu.indexOf('pages/index/index') > -1) {
            swan.webView.switchTab({ url: link.baidu });
          } else {
            swan.webView.navigateTo({ url: link.baidu });
          }
        } else {
          window.location.href = link.h5;
        }
      });
    } catch (e) {
      window.location.href = link.h5;
    }
  } else if (isXhs()) {
    try {
      if (link.baidu.indexOf('pages/index/index') > -1) {
        // 也使用百度的链接
        xhs.miniProgram.switchTab({ url: link.baidu });
      } else {
        // 也使用百度的链接
        xhs.miniProgram.navigateTo({ url: link.baidu });
      }
    } catch (e) {
      window.location.href = link.h5;
    }
  } else if (isAlipayClient()) {
    // 支付宝小程序
    var appId = link.XCXType === 2 ? '2021001107624185' : '2019040363776271';
    try {
      my.getEnv(function (res) {
        if (res.miniprogram) {
          if (link.alipay.indexOf('pages/index/index') > -1) {
            my.switchTab({ url: link.alipay });
          } else {
            if (link.XCXType === 2 && getQueryString('xcxType') === 'hzlx') {
              my.postMessage({ // 跳转到其他小程序使用发通知的方式
                data: {
                  type: "toMini",
                  appId: appId,
                  path: link.alipay
                }
              });
            } else {
              my.navigateTo({ url: link.alipay });
            }
          }
        } else {
          location.href = 'alipays://platformapi/startapp?appId=' + appId + '&page=' + link.alipay;
        }
      });
    } catch (e) {
      location.href = 'alipays://platformapi/startapp?appId=' + appId + '&page=' + link.alipay;
    }
  } else if (openInWebview()) {
    // 客户端
    if (isAndroid()) {
      if (versionCallBack) {
        // 安卓根据版本单独处理
        var obj = openInHuazhuWebview();
        if (obj) {
          var version = obj.version;
          if (version >= versionCallBack.version) {
            versionCallBack.androidCallBack();
          } else {
            context.$http.get(link.android);
          }
        } else {
          context.$http.get(link.android);
        }
      } else {
        context.$http.get(link.android);
      }
    } else {
      if (versionCallBack) {
        // ios根据版本单独处理
        var _obj = openInHuazhuWebview();
        if (_obj.version >= versionCallBack.version) {
          versionCallBack.iosCallBack();
        } else {
          loadURL(link.ios);
        }
      } else {
        loadURL(link.ios);
      }
    }
  } else {
    // h5
    window.location.href = link.h5;
  }
}

/*
    * 跳转到小程序
    * 只有小程序才有的
    */
function toXCX(context, linkUrl) {
  var wxUrl = '/' + linkUrl;
  var baidu = wxUrl;
  var alipay = wxUrl;
  var android = '';
  var ios = android;
  var h5 = '';
  var link = {
    wxUrl: wxUrl, baidu: baidu, alipay: alipay, android: android, ios: ios, h5: h5
  };
  jumpPage(link, context);
}

/*
    * 跳转到首页
    */
function toAppHome(context) {
  var wxUrl = '/pages/index/index';
  var baidu = wxUrl;
  var alipay = wxUrl;
  var android = 'H5_APP_DISCOUNT_BOOOK_HOTEL';
  var ios = android;
  var h5 = "https://m.lvyuetravel.com" + '/homePage';
  var link = {
    wxUrl: wxUrl, baidu: baidu, alipay: alipay, android: android, ios: ios, h5: h5
  };
  jumpPage(link, context);
}

/*
 * 跳转到详情页
 */
function toHotelDetail(id, context) {
  var wxUrl = '/pages/hotelDetail/hotelDetail?hotelId=' + id + '&channel=' + global.populationChannelCode + '&activity=' + global.populationActivityCode;
  var baidu = wxUrl;
  var alipay = wxUrl;
  var android = 'H5_STORE_HOUSE_SEE_HOTEL_' + id;
  var ios = android;
  var h5 = "https://m.lvyuetravel.com" + '/hotelDetail/' + id;
  var link = {
    wxUrl: wxUrl, baidu: baidu, alipay: alipay, android: android, ios: ios, h5: h5
  };
  jumpPage(link, context);
}

/*
 * 跳转到花粉去哪儿详情页
 */
function toHuafenDetail(code, id, context) {
  var wxUrl = '/pages/detail/detail?productId=' + code + '&mainCategoryId=' + id;
  var baidu = wxUrl;
  var alipay = wxUrl;
  var XCXType = 1;
  var link = {
    wxUrl: wxUrl, baidu: baidu, alipay: alipay, XCXType: XCXType
  };
  jumpPage(link, context);
}

/*
* 跳转到列表页
*/
function toHotelList(searchKey, searchName, regionType, context) {
  sessionStorage.setItem('searchKey', searchKey);
  sessionStorage.setItem('searchName', searchName);
  sessionStorage.setItem('searchType', regionType);

  var wxUrl = '/pages/hotelList/hotelList?searchType=' + regionType + '&name=' + searchName + '&param=' + searchKey;
  var baidu = '/pages/hotelList/hotelList?searchType=' + regionType + '&name=' + encodeURIComponent(searchName) + '&param=' + searchKey;
  var alipay = baidu;
  var android = 'H5_APP_DISCOUNT_BOOOK_HOTEL';
  var ios = android;
  var h5 = "https://m.lvyuetravel.com" + '/hotelList/';
  var link = {
    wxUrl: wxUrl, baidu: baidu, alipay: alipay, android: android, ios: ios, h5: h5
  };
  var versionCallBack = {
    version: 20100,
    androidCallBack: function androidCallBack() {
      androidObj.appHotelList(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
        type: regionType,
        param: searchKey,
        searchContent: searchName
      }));
    },
    iosCallBack: function iosCallBack() {
      window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.appHotelList && window.webkit.messageHandlers.appHotelList.postMessage && window.webkit.messageHandlers.appHotelList.postMessage({
        type: regionType,
        param: searchKey.toString(),
        searchContent: searchName
      });
    }
  };
  jumpPage(link, context, versionCallBack);
}

// app v2.2以后使用

var HuazhuJsbridge = {
  callHandler: function callHandler(handler, params, callback) {
    var cb = 'JsbridgeCallback' + new Date().getTime();
    window[cb] = callback || function () {};
    if (window.androidObj && window.androidObj.hasOwnProperty(handler)) {
      window.androidObj[handler](__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(params), cb);
    }
    if (window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.hasOwnProperty(handler)) {
      window.webkit.messageHandlers[handler].postMessage({ json: params, cb: cb });
    }
  }
};

/*
* 登录
*/
function login(callback, cbWebview) {
  __WEBPACK_IMPORTED_MODULE_2__sensors__["a" /* sensors */].track('registerButtonClick', {
    login_entrance: document.title,
    platformType: 'h5'
  });
  if (openInWebview()) {
    var obj = openInHuazhuWebview();
    if (isAndroid()) {
      if (obj) {
        var version = obj.version;
        if (version >= 220) {
          HuazhuJsbridge.callHandler('appLogin', {
            pagePosition: "立即登录",
            loginEntrance: document.title
          }, function (jsonStr) {
            try {
              var userObj = JSON.parse(jsonStr);
              if (userObj.state) {
                __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.set('ows_token', userObj.token, {
                  domain: '.lvyuetravel.com',
                  expires: 15 * 60 * 1000,
                  path: '/'
                });
                global.isLogin = true;
                cbWebview();
              }
            } catch (e) {
              console.log(e);
            }
          });
        } else if (version >= 202) {
          androidObj.toLogin('立即登录', document.title); // page_positon login_entrance
        } else {
          androidObj.toLogin();
        }
      } else {
        try {
          androidObj.toLogin();
        } catch (e) {
          console.log(e);
        }
      }
    } else {
      if (obj) {
        var _version2 = obj.version;
        if (_version2 >= 220) {
          HuazhuJsbridge.callHandler('appLogin', {
            pagePosition: "立即登录",
            loginEntrance: document.title
          }, function (jsonStr) {
            try {
              var userObj = JSON.parse(jsonStr);
              if (userObj.state) {
                __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.set('ows_token', userObj.token, {
                  domain: '.lvyuetravel.com',
                  expires: 15 * 60 * 1000,
                  path: '/'
                });
                global.isLogin = true;
                cbWebview();
              }
            } catch (e) {
              console.log(e);
            }
          });
        } else {
          loadURL("H5_APP_DISCOUNT_UNLOGIN_HOTEL");
        }
      } else {
        loadURL("H5_APP_DISCOUNT_UNLOGIN_HOTEL");
      }
    }
  } else {
    if (isWeixin()) {
      try {
        wx.miniProgram.getEnv(function (res) {
          if (res.miniprogram) {
            wx.miniProgram.redirectTo({ url: '/pages/login/login?target=' + window.location.href });
          } else {
            callback();
          }
        });
      } catch (e) {
        callback();
      }
    } else if (isBaiDu()) {
      try {
        swan.webView.getEnv(function (res) {
          if (res.smartprogram) {
            swan.webView.redirectTo({ url: '/pages/login/login?target=' + window.location.href });
          } else {
            callback();
          }
        });
      } catch (e) {
        callback();
      }
    } else if (isAlipayClient()) {
      try {
        my.getEnv(function (res) {
          if (res.miniprogram) {
            my.redirectTo({ url: '/pages/login/login?target=' + window.location.href });
          } else {
            callback();
          }
        });
      } catch (e) {
        callback();
      }
    } else {
      callback();
    }
  }
}

/*
* 跳转判断
*/
function goUrl(linkUrl, context) {
  if (linkUrl) {
    var search = linkUrl.split('?')[1];
    if (linkUrl.indexOf('pages/index/index') > -1) {
      // 内部跳转-首页
      toAppHome(context);
    } else if (linkUrl.indexOf('pages/hotelDetail/index') > -1) {
      // 内部跳转-详情页
      var id = getQueryString('hotelId', search);
      toHotelDetail(id, context);
    } else if (linkUrl.indexOf('pages/hotelList/index') > -1) {
      // 内部跳转-列表页
      var searchKey = getQueryString('searchKey', search);
      var searchName = getQueryString('searchName', search);
      var searchType = getQueryString('searchType', search);
      toHotelList(searchKey, searchName, searchType, context);
    } else if (!isExternal(linkUrl)) {
      toXCX(context, linkUrl);
    } else {
      // 跳其他链接 replace
      window.location.href = linkUrl;
    }
  }
}

/*
* 格式化评分
*/
function scoreFormat(val) {
  var len = val.toString().split('.').length;
  return len > 1 ? val : val + '.0';
}

/*
* 复制
*/
function copyToClipboard(element, cb) {
  var editable = element.hasAttribute('contenteditable');
  var selection = window.getSelection();
  var nodeName = element.nodeName;

  if (nodeName === 'SELECT') {
    element.focus();
  } else if (nodeName === 'TEXTAREA' || nodeName === 'INPUT') {
    element.select();
  } else {
    if (!editable) {
      element.setAttribute('contenteditable', true);
    }
    // element.focus();
    var range = document.createRange();

    range.selectNodeContents(element);
    selection.removeAllRanges();
    selection.addRange(range);
  }
  document.execCommand('copy');
  element.blur();
  element.setAttribute('contenteditable', editable);
  selection.removeAllRanges();
  if (cb) {
    cb();
  }
}

/*
* 根据选择的国家码返回控制手机号长度
* */
function changeAreaCode(val, cb) {
  var country = val[0].split("-")[0];
  var num = void 0;
  switch (country) {
    case '852':
    case '853':
    case '65':
      num = 8;
      break;
    case '886':
    case '66':
      num = 9;
      break;
    case '60':
    case '81':
    case '82':
      num = 10;
      break;
    case '86':
      num = 11;
      break;
    default:
      num = 10;
  }
  cb(country, num);
}

/*
* 是不是超链接
* */
function isExternal(path) {
  return (/^(https?:|mailto:|tel:)/.test(path)
  );
}

function debounce(fn, wait, immediate) {
  var timer = null;
  return function () {
    var _this = this;

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (timer) clearTimeout(timer);
    if (immediate && !timer) {
      fn.apply(this, args);
    }
    timer = setTimeout(function () {
      fn.apply(_this, args);
    }, wait);
  };
}

function throttle(func, delay) {
  var prev = Date.now();
  return function () {
    var context = this;
    var now = Date.now();
    if (now - prev >= delay) {
      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      func.apply(context, args);
      prev = Date.now();
    }
  };
}

var getTouchType = function getTouchType() {
  return getQueryString('goldmineMsgId') || getQueryString('pushId') || '运营位';
};
var getSuperiorPage = function getSuperiorPage() {
  if (getQueryString('goldmineMsgId')) {
    return '短信';
  } else if (getQueryString('pushId')) {
    return 'push';
  }
  return 'banner';
};

var isElementInViewport = function isElementInViewport(el) {
  var rect = el.getBoundingClientRect();
  return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
};

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app-eae72f41f6346a99c2d7.js